import DatePickerLocale from 'rmc-date-picker/lib/locale/zh_CN';

export default {
  okText: '确定',
  dismissText: '取消',
  DatePickerLocale,
};



/** WEBPACK FOOTER **
 ** ./components/date-picker/locale/zh_CN.tsx
 **/